<template>
  <div class="store-application">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-content">
        <div class="header-left">
          <el-button @click="$router.go(-1)" size="medium" class="back-btn">
            <i class="el-icon-arrow-left"></i> 返回
          </el-button>
          <div class="header-info">
            <h1 class="page-title">
              <i class="el-icon-s-shop"></i>
              门店入驻申请
            </h1>
            <p class="page-subtitle">加入祯丹堂，成为我们的合作伙伴</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 申请进度 -->
    <div class="progress-section">
      <div class="progress-container">
        <el-steps :active="currentStep" finish-status="success" align-center>
          <el-step title="填写申请信息" icon="el-icon-edit"></el-step>
          <el-step title="上传证件材料" icon="el-icon-upload"></el-step>
          <el-step title="提交申请" icon="el-icon-check"></el-step>
          <el-step title="等待审核" icon="el-icon-time"></el-step>
        </el-steps>
      </div>
    </div>

    <!-- 表单内容 -->
    <div class="main-content">
      <div class="form-container">
        <el-form
          ref="applicationForm"
          :model="form"
          :rules="rules"
          label-width="120px"
          class="application-form"
        >
          <!-- 基本信息 -->
          <div class="form-section">
            <div class="section-header">
              <h3><i class="el-icon-user"></i>申请人信息</h3>
              <p>请填写真实有效的申请人信息</p>
            </div>
            
            <div class="form-grid">
              <el-form-item label="申请人姓名" prop="applicant_name" class="form-item">
                <el-input
                  v-model="form.applicant_name"
                  placeholder="请输入申请人真实姓名"
                  maxlength="50"
                  clearable
                />
              </el-form-item>

              <el-form-item label="联系电话" prop="applicant_phone" class="form-item">
                <el-input
                  v-model="form.applicant_phone"
                  placeholder="请输入11位手机号码"
                  maxlength="11"
                  clearable
                />
              </el-form-item>
            </div>
          </div>

          <!-- 门店信息 -->
          <div class="form-section">
            <div class="section-header">
              <h3><i class="el-icon-s-shop"></i>门店信息</h3>
              <p>请详细填写门店基本信息</p>
            </div>
            
            <div class="form-grid">
              <el-form-item label="门店名称" prop="store_name" class="form-item">
                <el-input
                  v-model="form.store_name"
                  placeholder="请输入门店名称"
                  maxlength="100"
                  clearable
                />
              </el-form-item>

              <el-form-item label="门店类型" prop="store_type" class="form-item">
                <el-select v-model="form.store_type" placeholder="请选择门店类型" style="width: 100%">
                  <el-option label="实体门店" :value="1">
                    <div class="option-content">
                      <i class="el-icon-s-shop"></i>
                      <span>实体门店</span>
                    </div>
                  </el-option>
                  <el-option label="代理商" :value="2">
                    <div class="option-content">
                      <i class="el-icon-user"></i>
                      <span>代理商</span>
                    </div>
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="所在省份" prop="province" class="form-item">
                <el-input
                  v-model="form.province"
                  placeholder="请输入省份"
                  maxlength="50"
                  clearable
                />
              </el-form-item>

              <el-form-item label="所在城市" prop="city" class="form-item">
                <el-input
                  v-model="form.city"
                  placeholder="请输入城市"
                  maxlength="50"
                  clearable
                />
              </el-form-item>

              <el-form-item label="所在区县" prop="district" class="form-item">
                <el-input
                  v-model="form.district"
                  placeholder="请输入区县"
                  maxlength="50"
                  clearable
                />
              </el-form-item>

              <el-form-item label="详细地址" prop="address" class="form-item full-width">
                <el-input
                  v-model="form.address"
                  placeholder="请输入详细地址"
                  maxlength="200"
                  clearable
                />
              </el-form-item>
            </div>
          </div>

          <!-- 证件上传 -->
          <div class="form-section">
            <div class="section-header">
              <h3><i class="el-icon-upload"></i>证件材料</h3>
              <p>请上传相关证件照片，确保图片清晰可见</p>
            </div>
            
            <div class="upload-grid">
              <div class="upload-item">
                <label class="upload-label">营业执照</label>
                <el-upload
                  class="upload-demo"
                  action=""
                  :http-request="handleUpload"
                  :show-file-list="false"
                  :before-upload="beforeUpload"
                  accept="image/*"
                >
                  <div class="upload-area" :class="{ 'has-image': form.business_license }">
                    <div v-if="!form.business_license" class="upload-placeholder">
                      <i class="el-icon-plus"></i>
                      <div class="upload-text">上传营业执照</div>
                    </div>
                    <div v-else class="upload-preview">
                      <img :src="form.business_license" class="preview-image" alt="营业执照">
                      <div class="upload-mask">
                        <i class="el-icon-view" @click.stop="previewImage(form.business_license)"></i>
                        <i class="el-icon-delete" @click.stop="removeImage('business_license')"></i>
                      </div>
                    </div>
                  </div>
                </el-upload>
                <div class="upload-tip">支持JPG、PNG格式，大小不超过2MB</div>
              </div>

              <div class="upload-item">
                <label class="upload-label">身份证正面</label>
                <el-upload
                  class="upload-demo"
                  action=""
                  :http-request="handleUpload"
                  :show-file-list="false"
                  :before-upload="beforeUpload"
                  accept="image/*"
                >
                  <div class="upload-area" :class="{ 'has-image': form.id_card_front }">
                    <div v-if="!form.id_card_front" class="upload-placeholder">
                      <i class="el-icon-plus"></i>
                      <div class="upload-text">上传身份证正面</div>
                    </div>
                    <div v-else class="upload-preview">
                      <img :src="form.id_card_front" class="preview-image" alt="身份证正面">
                      <div class="upload-mask">
                        <i class="el-icon-view" @click.stop="previewImage(form.id_card_front)"></i>
                        <i class="el-icon-delete" @click.stop="removeImage('id_card_front')"></i>
                      </div>
                    </div>
                  </div>
                </el-upload>
                <div class="upload-tip">请确保证件信息清晰可见</div>
              </div>

              <div class="upload-item">
                <label class="upload-label">身份证背面</label>
                <el-upload
                  class="upload-demo"
                  action=""
                  :http-request="handleUpload"
                  :show-file-list="false"
                  :before-upload="beforeUpload"
                  accept="image/*"
                >
                  <div class="upload-area" :class="{ 'has-image': form.id_card_back }">
                    <div v-if="!form.id_card_back" class="upload-placeholder">
                      <i class="el-icon-plus"></i>
                      <div class="upload-text">上传身份证背面</div>
                    </div>
                    <div v-else class="upload-preview">
                      <img :src="form.id_card_back" class="preview-image" alt="身份证背面">
                      <div class="upload-mask">
                        <i class="el-icon-view" @click.stop="previewImage(form.id_card_back)"></i>
                        <i class="el-icon-delete" @click.stop="removeImage('id_card_back')"></i>
                      </div>
                    </div>
                  </div>
                </el-upload>
                <div class="upload-tip">请确保证件信息清晰可见</div>
              </div>
            </div>
          </div>

          <!-- 申请说明 -->
          <div class="form-section">
            <div class="section-header">
              <h3><i class="el-icon-edit-outline"></i>申请说明</h3>
              <p>请简述您的申请理由和经营计划</p>
            </div>
            
            <el-form-item label="申请理由" prop="application_reason" class="form-item">
              <el-input
                v-model="form.application_reason"
                type="textarea"
                :rows="4"
                placeholder="请简述您申请成为祯丹堂门店/代理的理由和经营计划"
                maxlength="500"
                show-word-limit
              />
            </el-form-item>
          </div>

          <!-- 提交按钮 -->
          <div class="form-actions">
            <el-button @click="handleCancel" size="large">取消申请</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" size="large">
              <i class="el-icon-check"></i> 提交申请
            </el-button>
          </div>
        </el-form>
      </div>
    </div>

    <!-- 图片预览对话框 -->
    <el-dialog :visible.sync="imagePreviewVisible" width="60%" center>
      <img :src="previewImageUrl" style="width: 100%" alt="预览图片">
    </el-dialog>
  </div>
</template>

<script>
import { createStoreApplication } from '@/api/store'
import { uploadImage } from '@/api/upload'

export default {
  name: 'StoreApplication',
  
  data() {
    return {
      currentStep: 0,
      submitLoading: false,
      imagePreviewVisible: false,
      previewImageUrl: '',
      uploadingField: '', // 当前上传的字段
      form: {
        applicant_name: '',
        applicant_phone: '',
        store_name: '',
        store_type: 1,
        business_license: '',
        id_card_front: '',
        id_card_back: '',
        application_reason: '',
        address: '',
        province: '',
        city: '',
        district: ''
      },
      rules: {
        applicant_name: [
          { required: true, message: '请输入申请人姓名', trigger: 'blur' },
          { min: 2, max: 50, message: '姓名长度为2-50个字符', trigger: 'blur' }
        ],
        applicant_phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        store_name: [
          { required: true, message: '请输入门店名称', trigger: 'blur' },
          { min: 2, max: 100, message: '门店名称长度为2-100个字符', trigger: 'blur' }
        ],
        store_type: [
          { required: true, message: '请选择门店类型', trigger: 'change' }
        ],
        province: [
          { required: true, message: '请输入所在省份', trigger: 'blur' }
        ],
        city: [
          { required: true, message: '请输入所在城市', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
          { min: 5, max: 200, message: '地址长度为5-200个字符', trigger: 'blur' }
        ],
        application_reason: [
          { min: 10, max: 500, message: '申请理由长度为10-500个字符', trigger: 'blur' }
        ]
      }
    }
  },
  
  methods: {
    // 文件上传前校验
    beforeUpload(file) {
      const isImage = /^image\//.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },

    // 自定义上传
    async handleUpload(options) {
      try {
        const response = await uploadImage(options.file, {
          type: 'license',
          module: 'store'
        })
        
        // 根据当前上传的字段设置对应的值
        const fieldName = this.getUploadFieldName(options.file.name)
        if (fieldName) {
          this.form[fieldName] = response.data.url
          this.$message.success('图片上传成功')
        }
        
      } catch (error) {
        console.error('上传失败:', error)
        this.$message.error('图片上传失败')
      }
    },

    // 根据文件名或其他条件确定上传字段
    getUploadFieldName(filename) {
      // 这里可以根据实际需要来确定字段名
      // 暂时返回第一个空的字段
      if (!this.form.business_license) return 'business_license'
      if (!this.form.id_card_front) return 'id_card_front'  
      if (!this.form.id_card_back) return 'id_card_back'
      return 'business_license' // 默认
    },

    // 删除图片
    removeImage(field) {
      this.form[field] = ''
      this.$message.success('图片已删除')
    },

    // 预览图片
    previewImage(url) {
      this.previewImageUrl = url
      this.imagePreviewVisible = true
    },

    // 提交申请
    async handleSubmit() {
      try {
        await this.$refs.applicationForm.validate()
        
        this.submitLoading = true
        
        const response = await createStoreApplication(this.form)
        
        this.$message.success('申请提交成功，请等待审核')
        
        // 跳转到申请记录页面
        this.$router.push('/my-applications')
        
      } catch (error) {
        console.error('提交申请失败:', error)
        if (error !== 'cancel') {
          this.$message.error(error.message || '提交申请失败')
        }
      } finally {
        this.submitLoading = false
      }
    },
    
    // 取消申请
    handleCancel() {
      this.$confirm('确定要取消申请吗？已填写的信息将丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '继续填写',
        type: 'warning'
      }).then(() => {
        this.$router.back()
      }).catch(() => {
        // 用户选择继续填写
      })
    }
  }
}
</script>

<style scoped>
/* 页面基础样式 */
.store-application {
  min-height: 100vh;
  background: #f5f7fa;
}

/* 页面头部 */
.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 25px 40px;
  margin-bottom: 30px;
  box-shadow: 0 2px 10px rgba(102, 126, 234, 0.3);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 20px;
}

.back-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.header-info .page-title {
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
}

.header-info .page-title i {
  font-size: 32px;
  color: white;
}

.header-info .page-subtitle {
  font-size: 16px;
  opacity: 0.9;
  margin: 0;
  line-height: 1.5;
  color: white;
}

/* 进度条区域 */
.progress-section {
  background: white;
  padding: 30px;
  margin-bottom: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.progress-container {
  max-width: 800px;
  margin: 0 auto;
}

/* 主内容区域 */
.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 30px;
}

.form-container {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #f1f3f4;
}

/* 表单区块 */
.form-section {
  margin-bottom: 40px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f2f5;
}

.section-header h3 {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-header h3 i {
  color: #667eea;
  font-size: 22px;
}

.section-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

/* 表单网格 */
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.form-item {
  margin-bottom: 0;
}

.form-item.full-width {
  grid-column: 1 / -1;
}

/* 选择器选项样式 */
.option-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.option-content i {
  font-size: 16px;
}

/* 上传区域 */
.upload-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.upload-item {
  text-align: center;
}

.upload-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #606266;
  margin-bottom: 12px;
}

.upload-area {
  width: 150px;
  height: 100px;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
}

.upload-area:hover {
  border-color: #667eea;
}

.upload-area.has-image {
  border-color: #67c23a;
  border-style: solid;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #666;
}

.upload-placeholder i {
  font-size: 24px;
}

.upload-text {
  font-size: 12px;
}

.upload-preview {
  width: 100%;
  height: 100%;
  position: relative;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  opacity: 0;
  transition: opacity 0.3s;
}

.upload-preview:hover .upload-mask {
  opacity: 1;
}

.upload-mask i {
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.3s;
}

.upload-mask i:hover {
  background: rgba(255, 255, 255, 0.2);
}

.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
}

/* 表单操作按钮 */
.form-actions {
  text-align: center;
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid #f0f2f5;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 12px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .upload-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .page-header {
    padding: 20px;
  }
  
  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .main-content {
    padding: 16px 20px;
  }
  
  .form-container {
    padding: 24px 20px;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .upload-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .upload-area {
    width: 200px;
    height: 120px;
  }
  
  .form-actions .el-button {
    width: 100%;
    margin: 8px 0;
  }
}
</style>
